/* eslint-disable max-len */
export const UpdateLocation = "/api/location/update";
export const GetLocation = "/api/location/get-location";
export const SearchCity = { url: "/api/location/search-city/%7Bname%7D", type: undefined as { name: string | number; } };
